module.exports = __webpack_public_path__ + "img/stop.c9c3e7ef.png";